import { render } from "./TableHeader.vue?vue&type=template&id=76a8280a&scoped=true&ts=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"

import "./TableHeader.vue?vue&type=style&index=0&id=76a8280a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a8280a"]])

export default __exports__